import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';

import {
  Form,
  ButtonsWrapper,
  Button,
  TextInput,
  PopoverTooltip,
  Typography,
  PLATFORM_THEME_COLORS,
  Icon,
  ICONS,
  UploadInput,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';

import { removeFileExtension } from 'src/common/helpers/common.helpers';

import { IDocumentImportPatternValues } from '../../change-document-import-pattern.interfaces';
import { DocumentImportLabel, LabelInfo, StyledForm } from './document-import-pattern-form.styles';



const DocumentImportPatternForm = ({
  onClose,
  onFinishHandler,
  initialValues,
  loading,
}: {
  loading?: boolean;
  onClose: () => void;
  onFinishHandler: (values: any) => void;
  initialValues: IDocumentImportPatternValues;
}) => {
  const { t } = useTranslation();

  return (
    <StyledForm
      layout="vertical"
      onFinish={values => onFinishHandler(values)}
      initialValues={initialValues}
    >
      <Form.Item
        name="title"
        label={t('settings:documentImporter.labels.title')}
        rules={[{ required: true, message: t('customers:error.fieldIsRequired') }]}
      >
        <TextInput placeholder={t('settings:documentImporter.labels.titlePlaceholder')} />
      </Form.Item>

      <Form.Item
        name="separator"
        label={
          <DocumentImportLabel>
            <Typography>{t('settings:documentImporter.labels.separator')}</Typography>
            <PopoverTooltip
              placement="top"
              overlayInnerStyle={{ width: '328px' }}
              trigger={'hover'}
              overlay={
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.white}>
                  {t('settings:documentImporter.labels.separatorPopup')}
                </Typography>
              }
            >
              <LabelInfo>
                <Icon
                  icon={ICONS.infoCircleRegular}
                  color={PLATFORM_THEME_COLORS.primary.blue}
                  size={20}
                  leftMargin={false}
                  rightMargin={false}
                />
              </LabelInfo>
            </PopoverTooltip>
          </DocumentImportLabel>
        }
        rules={[{ required: true, message: t('customers:error.fieldIsRequired') }]}
      >
        <TextInput placeholder={'_'} maxLength={1} />
      </Form.Item>

      <Form.Item
        name="templateFileId"
        valuePropName="file"
        rules={[
          {
            required: true,
            message: t('common:validation.error.fieldRequired'),
          },
        ]}
        label={t('settings:documentImporter.labels.exampleFile')}
      >
        <UploadInput
          showUploadList
          className={'upload-file-field'}
          beforeUpload={() => false}
          btnText={t('settings:documents.buttons.uploadFile')}
          variant={'button'}
          accept=".pdf"
          maxCount={1}
        />
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const { fileList, file } = getFieldValue('templateFileId') || {};
          const separator = getFieldValue('separator');

          return !isEmpty(fileList) && separator ? (
            <Form.Item
              name="valueEmployeeId"
              label={t('settings:documentImporter.labels.valueEmployeeId')}
              rules={[{ required: true, message: t('common:validation.error.fieldRequired') }]}
            >
              <SelectInput placeholder="">
                {file?.name &&
                  removeFileExtension(file.name)
                    .split(separator)
                    .map((el: string, index) => (
                      <SelectInput.Option key={el} value={index}>
                        {el}
                      </SelectInput.Option>
                    ))}
              </SelectInput>
            </Form.Item>
          ) : null;
        }}
      </Form.Item>

      <ButtonsWrapper marginTop={16}>
        <Button type="primary" loading={loading} htmlType="submit">
          {t('common:buttons.save')}
        </Button>
        <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </StyledForm>
  );
};

export default DocumentImportPatternForm;
